import { FunctionComponent, SVGProps } from 'react'
import { Box, Button, Text, Inline, Columns, Column } from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'
import { useTranslation } from 'react-i18next'

type Props = {
  card: {
    title: string
    icon: FunctionComponent<SVGProps<SVGSVGElement>>
    credits: string
    useCreditVariant: 'solid' | 'ghost' | 'transparent' | 'soft' | undefined
    useCreditText: string
    useCreditId: string
    useCreditDisabled?: boolean
    useCreditOnClick: () => void
    buyMoreOnClick?: () => void
    buyMoreId?: string
  }
}

const MobileCard = ({ card }: Props) => {
  const { t } = useTranslation()
  const Icon = card.icon
  return (
    <Box
      key={card.title}
      borderRadius="large"
      padding="medium"
      gap="xsmall"
      display="flex"
      flexDirection="column"
      justifyContent="spaceBetween"
      maxWidth="xsmall"
      width="full"
      style={{ border: `1px solid ${vars.borderColor.neutralLight}` }}
    >
      <Inline space="xsmall">
        <Box display="flex" flexDirection="row" gap="xsmall">
          <Box>
            <Icon />
          </Box>
          <Box display="flex" flexDirection="column" gap="xxxsmall">
            <Text size="medium" weight="strong" baseline={false}>
              {card.title}
            </Text>
            <Text size="small" weight="medium" baseline={false}>
              {t('l.credit_usage.product.credits.title', 'Credits')}: {card.credits}
            </Text>
          </Box>
        </Box>
      </Inline>
      <Columns space="small" align="right">
        {card?.buyMoreOnClick ? (
          <Column width="1/2">
            <Button
              size="small"
              variant="solid"
              onClick={card?.buyMoreOnClick}
              id={card?.buyMoreId}
            >
              <Box paddingX="xsmall">{t('l.credit_usage.product.buy_more.action', 'Buy more')}</Box>
            </Button>
          </Column>
        ) : null}
        <Column width={card?.buyMoreOnClick ? undefined : '1/2'}>
          <Button
            size="small"
            variant={card.useCreditVariant}
            onClick={card?.useCreditOnClick}
            disabled={card?.useCreditDisabled}
            id={card?.useCreditId}
          >
            <Box paddingX="xsmall">{card.useCreditText}</Box>
          </Button>
        </Column>
      </Columns>
    </Box>
  )
}

export default MobileCard
